export const footer = {
    pt: {
        rights: "Black Paladins. Todos os direitos reservados."
    },
    en: {
        rights: "Black Paladins. All rights reserved."
    }
}